import * as PIXI from "pixi.js";


export default class DampedSpring
{
    // #region Attributes //

    // private:

    private _springConstant: number = null;
    
    private _follower: PIXI.DisplayObject = null;
    private _target: PIXI.Point = null;
    private _velocity: PIXI.Point = null;
    private _velocityFactor: number = null;
    private _isAwake: boolean = null;

    // Constants.
    private readonly _kIdealFrameRate: number = 1/30;

    // #endregion //


    // #region Properties //

    public set springConstant( value: number ) { this._springConstant = value; }

    public get target(): PIXI.Point { return this._target; }
    public get isAwake(): boolean { return this._isAwake; }

    // #endregion //


    // #region Methods //

    // public:

    public init(): void
    {
        console.assert( this._springConstant != null, "DampedSpring.ts :: init() :: this._springConstant cannot be null." );
    
        this._target = new PIXI.Point();
        this._velocity = new PIXI.Point();

        this._velocityFactor = Math.sqrt( this._springConstant ) * 2;

        this._isAwake = false;
    }

    public end(): void
    {
        this._springConstant = null;
        this._follower = null;
        this._target = null;
        this._velocity = null;
        this._velocityFactor = null;
        this._isAwake = null;
    }

    public update( dt: number ): void
    {
        if ( this._isAwake )
        {
            do
            {
                let dtAux: number = dt;
                if ( dtAux > this._kIdealFrameRate )
                {
                    dtAux = this._kIdealFrameRate;
                }

                const kTo: PIXI.Point = new PIXI.Point( this._target.x - this._follower.position.x, this._target.y - this._follower.position.y );
                const kSpringForce: PIXI.Point = new PIXI.Point( kTo.x * this._springConstant, kTo.y * this._springConstant );
                const kDampingForce: PIXI.Point = new PIXI.Point( -this._velocity.x * this._velocityFactor, -this._velocity.y * this._velocityFactor );
                
                this._velocity.x += ( kSpringForce.x + kDampingForce.x ) * dtAux;
                this._velocity.y += ( kSpringForce.y + kDampingForce.y ) * dtAux;
        
                this._follower.position.x += this._velocity.x * dtAux;
                this._follower.position.y += this._velocity.y * dtAux;
 
                dt -= dtAux;
            }
            while ( dt > 0 );

            this._isAwake = Math.round( this._target.x ) != Math.round( this._follower.position.x )
                || Math.round( this._target.y ) != Math.round( this._follower.position.y );
        }
    }

    public setFollower( follower: PIXI.DisplayObject ): void
    {
        this._follower = follower;

        this._target.copyFrom( follower.position );
        this._velocity = new PIXI.Point();
    }

    public setTarget( x: number, y: number ): void
    {
        console.assert( this._follower != null, "DampedSpring.ts :: setTarget() :: this._follower cannot be null." );

        this._target.x = x;
        this._target.y = y;

        this._isAwake = true;
    }

    public moveTargetBy( dx: number, dy: number ): void
    {
        console.assert( this._follower != null, "DampedSpring.ts :: moveTargetBy() :: this._follower cannot be null." );

        this._target.x += dx;
        this._target.y += dy;

        this._isAwake = true;
    }

    public clear(): void
    {
        this._follower = null;
        this._target = new PIXI.Point();
        this._velocity = new PIXI.Point();
        this._isAwake = false;
    }

    // #endregion //
}